export default __webpack_public_path__ + "static/1264-c94fa26c0f02721c7e04652b172db905.gif";